import { render, staticRenderFns } from "./TrainingArea.vue?vue&type=template&id=6c3f6ee1"
import script from "./TrainingArea.vue?vue&type=script&lang=js"
export * from "./TrainingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports